<template>
    <div class="box-container chart-absolute">
        <div :key="getLocale" class="box-container-header">
            <h2 class="box-title">
                {{ $t('DASHBOARD.TITLE.TREND') }}<!--상태 트랜드-->
                <select-box-single
                    :select-box-options="typeOptions"
                    :select-box-value="chartType"
                    :use-translate="true"
                    select-class="type-inline size-s chart-overlay"
                    select-id="select_trend_type"
                    @onSelectChange="changeChartType($event.value)"></select-box-single>
                <button :title="$t('DASHBOARD.TREND.TOOLTIP')" class="buttons-icon" data-icon="info" data-size="xs" data-trigger="tooltip"
                        data-type="ghost" type="button">info
                </button>
            </h2>

            <div class="actions">
                <select-box-single 
                    :select-box-options="rangeOptions"
                    :select-box-value="chartRange"
                    :use-translate="true"
                    select-class="type-inline size-s chart-overlay"
                    select-id="select_trend_range"
                    @onSelectChange="chartRange = $event.value; selectComplianceResultOfCategory()"></select-box-single>
                <dashboard-widget v-bind:type="'trend'"></dashboard-widget>
            </div>
        </div>

        <div v-show="!pending" :style="chartDataList.length > 0 ? {'height':'315px'} : {'height':'0','overflow':'hidden'}"
             class="chart chart-wrapper">
            <div id="chartdiv2" class="gv-dashboard-trend-chart chart-wrapper-absolute" style="height: 315px;">
            </div>
        </div>
        <div v-show="!pending && chartDataList.length === 0" class="chart chart-wrapper chart-info-text"
             style="height:283px;">
            <p>{{ $t('COMMON.NO_DATA') }}</p>
        </div>
        <div-loading v-if="pending"></div-loading>
    </div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

import DashboardWidget from "./dashboardWidget.vue"
import {mapGetters} from "vuex";

export default {
    name: 'DashboardTrend',
    components: {
        DashboardWidget
    },
    props: ['filter'],
    data: function () {
        return {
            chartType: "prodList", // prodList, ctgList 로 나뉨. prodList 가 기본 값
            chartRange: "14",
            labelList: [],
            rawDataList: [], // api 호출 데이터
            filterDataList: [], // filter 적용된 데이터
            chartDataList: [], // chart에 넣을 데이터
            pending: true,
            typeOptions: this.constants.CHART_TYPE_OPTIONS,
            rangeOptions: [
                {"key": "14", "val": "DASHBOARD.TREND.OPTION.LAST_14_DAYS"},
                {"key": "30", "val": "DASHBOARD.TREND.OPTION.LAST_1_MONTH"},
                {"key": "365", "val": "DASHBOARD.TREND.OPTION.LAST_1_YEAR"}
            ]
        }
    },
    computed: {
        ...mapGetters({
            curCmpnId: 'user/curCmpnId'
        }),
        getLocale() {
            return this.$i18n.locale
        }
    },
    watch: {
        getLocale() {
            this.applyFilterRawData()
        },
        filterDataList() {
            this.setData();
        }
    },
    methods: {
        async selectComplianceResultOfCategory() {
            const url = "/api/governance/dashboard/status";
            const header = {
                'dateRange': this.chartRange,
                'cmpnId': this.curCmpnId
            };
            const self = this;
            this.pending = true;
            try {
                const response = await this.http.post(url, JSON.stringify(header));
                if (response.data.status === 'ok') {
                    this.rawDataList = response.data.result;
                    _.remove(this.rawDataList, {'cmplRslt': 'E'});
                    setTimeout(function () {
                        self.applyFilterRawData();
                        self.pending = false;
                    }, 10)

                } else {
                    self.pending = false;
                }
            } catch (err) {
                console.error("selectComplianceResultOfCategory: ", err);
                self.pending = false;
            }
        },
        applyFilterRawData() { // data filtering
            let self = this;
            let data = this.rawDataList;
            // account filter 적용
            if (this.filter != null && this.filter.acnt != null && typeof (this.filter.acnt) !== 'undefined' && this.filter.acnt.length > 0) {
                data = _.filter(data, function (o) {
                    if(o.autoExeYn ==="N") return true;
                    let isInclude = false;
                    for (let acnt of self.filter.acnt) {
                        isInclude = _.includes(o.acnt, acnt)
                        if (isInclude) break;
                    }

                    return isInclude;
                });
            }

            this.filterDataList = data;
            this.setData();
        },
        checkChartRendered() {
            const chart = document.querySelector("#chartdiv2 > div > svg > g > g.amcharts-Sprite-group.amcharts-Rectangle-group > rect");
            if (chart.getAttribute("width") == 0) {
                console.log("No TrendChart found");
                this.setData();
            } else {
                console.log("TrendChart rendered");
            }
        },
        setData() {
            /** Data Setting Start*/
            const maxContents = 5;
            this.labelList = [];
            this.chartDataList = [];
            // labelList 만들기
            let self = this;
            for (let rule of this.filterDataList) {
              //  const ruleChartType = rule[this.chartType];
                if (typeof (rule[this.chartType]) == 'string') {
                    rule[this.chartType] = JSON.parse(rule[this.chartType]);
                }
                if (rule[this.chartType]) {
                    for (let type of rule[this.chartType]) {
                        let idx = _.findIndex(self.labelList, function (obj) {
                            return obj.objId == type
                        });
                        if (idx < 0) {
                            let obj = {
                                objId: type,
                                objNm: this.chartType == 'ctgList' ? type : this.$t('PRODUCT.' + type),
                                cnt: 1,

                            }
                            self.labelList.push(obj);
                        } else {
                            let obj = _.find(self.labelList, {'objId': type});
                            obj.cnt++;
                        }
                    }
                }
            }

            this.labelList = _.reverse(_.sortBy(self.labelList, [function (obj) {
                return obj['cnt']
            }]));

            if (this.labelList.length > maxContents) {
                this.labelList = this.labelList.splice(0, maxContents - 1);
                this.labelList.push({objId: 'etc', objNm: this.$t('PRODUCT.etc')});
            }


            // console.log('******************************************************************')
            // rule에 있는 timestamp를 groupby하여 chart raw data에 넣어줌
            let dateList = Object.keys(_.groupBy(self.filterDataList, 'timeStamp'));

            for (let date of dateList) {
                this.chartDataList.push({date: date});
            }
            this.chartDataList = _.sortBy(self.chartDataList, [function (obj) {
                return obj['date']
            }]);

            for (let raw of this.chartDataList) {
                for (let label of this.labelList) {
                    raw[label.objId] = {
                        [label.objId]: 0,
                        info: {
                            totCnt: 0,
                            sucsCnt: 0

                        },
                    };
                }
            }


            // if(this.chartDataList.length > maxContents){
            for (let raw of this.chartDataList) {
                // 해당 날짜에 실행된 rule 정보만 가져오기
                let ruleList = _.filter(self.filterDataList, function (o) {
                    return o.timeStamp == raw.date
                });
                raw.date = this.Common.convertDateDayByLang(raw.date, this.getLocale)
                // console.log('******************************************************************')
                // 날짜별로 category or product 카운트해주기
                raw.etc = {
                    date: raw.date,
                    info: {
                        totCnt: 0,
                        sucsCnt: 0

                    },
                };
                for (let rule of ruleList) {
                    const chartTypes = rule[this.chartType];
                    if (chartTypes) {
                        for (let type of chartTypes) {
                            let labelIndex = _.findIndex(self.labelList, function (obj) {
                                return obj.objId == type
                            });
                            if (labelIndex > -1) {
                                raw[type].info.totCnt++;
                                if (rule.cmplRslt == 'P') {
                                    raw[type].info.sucsCnt++;
                                }
                            } else {
                                raw.etc.info.totCnt++;
                                if (rule.cmplRslt == 'P') {
                                    raw.etc.info.sucsCnt++;
                                }
                            }
                        }
                    }
                }
            }

            // }

            // console.log('******************************************************************')
            // 점수 계산
            for (let raw of this.chartDataList) {
                raw.scale = 0;
                for (let label of this.labelList) {
                    raw[label.objId] = raw[label.objId].info.totCnt != 0 ? this.round(raw[label.objId].info.sucsCnt / raw[label.objId].info.totCnt * 100) : 0;
                }
            }

            /** Data Setting End */

            //auto add Class for customizing
            am4core.options.autoSetClassName = true;

            /* Create chart instance */
            const chart = am4core.create("chartdiv2", am4charts.XYChart);
            chart.events.on('ready', () => {
                console.log('TrendChart ready');
                self.checkChartRendered();
            });


            let date = new Date();
            date.setDate(date.getDate() - this.chartRange);
            let dateString = this.Common.convertDateDayByLang(date.toISOString().split('T')[0], this.getLocale);

            let listItem = [];
            if (_.findIndex(this.chartDataList, function(o) { return o.date == dateString; }) === -1) {
                let item = {date: dateString};
                for (let label of this.labelList) {
                    item[label.objId] = 0;
                }
                listItem.push(item);
            }

            listItem = listItem.concat(this.chartDataList);

            // chart에 넣을 data
            chart.data = listItem;

            let colorSet = new am4core.ColorSet();
            colorSet.list = ["#34CFC4", "#1EB9DD", "#5EA0F0", "#B56DD4", "#F3F4F5"].map(function (color) {
                return new am4core.color(color);
            });
            chart.colors = colorSet;

            let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
            categoryAxis.dataFields.category = "date"; // x축 결정하는 parameter id
            categoryAxis.fontSize = 12;
            categoryAxis.tooltip.disabled = true;


            /* Create value axis */
            let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.fontSize = 12;
            valueAxis.tooltip.disabled = true;

            /* Create axes */
            for (let i = 0; i < this.labelList.length; i++) {

                /* Create series */
                let field = this.labelList[i].objId; // 들어갈 값
                let title = this.labelList[i].objNm; // 하단에 보여질 라벨 이름
                let lineSeries = chart.series.push(new am4charts.LineSeries());
                lineSeries.dataFields.valueY = field;
                lineSeries.dataFields.categoryX = "date";
                lineSeries.name = title;
                lineSeries.fillOpacity = 0.6;
                lineSeries.strokeWidth = 2;
                lineSeries.tooltip.disabled = true;


                let bullet = lineSeries.bullets.push(new am4charts.CircleBullet());
                bullet.circle.radius = 4;
                bullet.circle.fill = am4core.color("#fff");
                bullet.circle.strokeWidth = 1;

                bullet.properties.scale = 1 //this.chartDataList.length === 1 ? 1 : 0;
                let hoverState = bullet.states.create("hover");
                hoverState.properties.scale = 1;
            }

            // chart tooltip, markup에서 lineseries 만들때 index == 0에서 툴팁 넣어주는거를 변수 넣기 위해서 별도로 뺌, html 형식은 아래 주석 확인할 것
            if (chart.series.values != null && chart.series.values.length > 0) {
                let lineSeries = chart.series.values[0];
                lineSeries.tooltip.disabled = false;
                lineSeries.tooltipHTML =
                    `<div class="gv-amchart-dashboard-tooltip"><h2>` + this.$t('DASHBOARD.TITLE.STATE') + ` {categoryX}</h2><table>`;

                for (let i = 0; i < chart.series.values.length; i++) {
                    lineSeries.tooltipHTML +=
                        `<tr>
                              <th align="left"><span class="label-maker" style="background-color:rgba(${(i < chart.colors.list.length ? chart.colors.list[i] : chart.colors.list[chart.colors.list.length - 1])._value.r},${(i < chart.colors.list.length ? chart.colors.list[i] : chart.colors.list[chart.colors.list.length - 1])._value.g},${(i < chart.colors.list.length ? chart.colors.list[i] : chart.colors.list[chart.colors.list.length - 1])._value.b},1)"></span>` + chart.series.values[i].name + `</th>
                            <td>{` + chart.series.values[i].dataFields.valueY + `} </td>
                            </tr>`
                }

                lineSeries.tooltipHTML += `</table></div>`;

                lineSeries.tooltip.background.fill = am4core.color("#FFF");
                lineSeries.tooltip.background.fillOpacity = 1;
                lineSeries.tooltip.background.cornerRadius = 0;
                lineSeries.tooltip.getFillFromObject = false;
                lineSeries.tooltip.fillOpacity = 1;
                lineSeries.tooltip.getStrokeFromObject = true;
                lineSeries.tooltip.background.cornerRadius = 0;
                lineSeries.tooltip.background.strokeWidth = 0;
                lineSeries.tooltip.zIndex = 5555;
            }

            /* Create a cursor */
            chart.cursor = new am4charts.XYCursor();
            /*chart.scrollbarX = new am4core.Scrollbar();*/


            // Add a legend
            chart.legend = new am4charts.Legend();
            chart.legend.position = "bottom";
            chart.legend.contentAlign = "center";
            chart.legend.paddingLeft = 20;
            chart.legend.paddingRight = 10;
            chart.legend.paddingTop = 10;
            chart.legend.paddingBottom = 0;
            chart.legend.fontSize = 12;

            chart.legend.itemContainers.template.events.on("hit", function (ev) {
                //ev.preventDefault();
            });

            // marker
            /*label marker styling*/

            chart.legend.useDefaultMarker = true;
            var marker = chart.legend.markers.template.children.getIndex(0);
            marker.cornerRadius(0, 0, 0, 0);
            //chart.legend.labels.template.text = "[#222222]{name}[/]";
            var markerTemplate = chart.legend.markers.template;
            markerTemplate.width = 8;
            markerTemplate.height = 8;
        },
        changeChartType(type) {
            if (type != this.chartType) {
                this.chartType = type;
                this.setData();
            }
        },
        round(i) {
            return this.Common.round(i, 2);
        }
    }

}
</script>

<style>
@import '../../../static/styles/gv_amchart.css';

.service-governance .gv-amchart-dashboard-tooltip h2 {
    font-size: .6875rem;
    line-height: 1.0625rem;
    color: #222;
}

.service-governance .gv-amchart-dashboard-tooltip table {
    width: 100%;
}

.service-governance .gv-amchart-dashboard-tooltip table th, .service-governance.dashboard .gv-amchart-dashboard-tooltip table td {
    font-size: .6875rem;
    line-height: 1.0625rem;
    color: #666;
}

.service-governance .gv-amchart-dashboard-tooltip table td {
    text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/dashboardTrend.vue